import React from 'react';
import I18N from '@leverege/i18n';
import { GlobalState, UI } from '@leverege/ui-redux';
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.actions.ExpandedAction');
export default function ExpandAction(molten) {
  return {
    id: 'molten.dataViewers.expandAction',
    matches: [{
      use: 'actionBar'
    }, {
      use: 'bottomRightActionBar'
    }],
    handles: context => {
      const {
        clientProps
      } = context;
      const {
        settings,
        expanded,
        isMobile
      } = clientProps || {};
      return !expanded && !isMobile && settings?.allowExpandedView;
      // would use a model getter, but this is cross model :thinking:
    },
    layout: {
      sort: 'zzzzz'
    },
    appearance: cxt => {
      const icon = tIcon('icon', 'fa-solid fa-arrow-up-right-and-arrow-down-left-from-center');
      return {
        icon,
        name: t('expand')
      };
    },
    perform: context => {
      const path = context?.context?.clientProps?.relationship?.parent?.path;
      GlobalState.dispatch(UI.set('expanded', {
        ...context,
        context: {
          ...context.context,
          clientProps: {
            ...context.context.clientProps,
            objectType: context.context.clientProps.objectType.split('.')[0]
          }
        }
      }));
      GlobalState.dispatch(UI.set('expandedPathname', window.location.pathname));
      const currentCollapsed = GlobalState.get()?.ui?.collapsed ?? {};
      GlobalState.dispatch(UI.set('collapsed', {
        ...currentCollapsed,
        [path]: true
      }));
    }
  };
}